module.exports = __webpack_public_path__ + "img/drawer_not_found.935c67b1.svg";